import { useUserStore } from '@/entities/User';
import { useModalStore } from '@/entities/Modal';
import { GoalsList } from '@/features/LK/GoalsList';
import { GoalModal } from '@/features/LK/GoalModal';
import { SkeletonWrapper } from '@/features/Skeleton';
import { ChosenGoal } from '@/features/LK/ChosenGoal';
import { useGlobalStore } from '@/entities/GlobalStore';
import { DepositModal } from '@/features/LK/DepositModal';
import { GoalChosenModal } from '@/features/LK/GoalChosenModal';
import { GoalUpdatedModal } from '@/features/LK/GoalUpdatedModal';
import cls from './Goals.module.scss';

export const Goals = () => {
    const {
        user: { goalRooms, percentLeftToAchieve },
        isUserLoading,
    } = useUserStore();
    const { setIsGoalModalOpen } = useModalStore();
    const { setSelectedGoalParams } = useGlobalStore();

    const isGoalChosen = goalRooms && percentLeftToAchieve;

    return (
        <SkeletonWrapper className={cls.container} width="100%" height="492px" isLoading={isUserLoading}>
            {isGoalChosen ? (
                <ChosenGoal />
            ) : (
                <GoalsList
                    onChangeModalParams={(params) => {
                        setSelectedGoalParams(params);
                        setIsGoalModalOpen(true);
                    }}
                />
            )}
            <GoalModal />
            <GoalChosenModal />
            <GoalUpdatedModal />
            <DepositModal />
        </SkeletonWrapper>
    );
};
